import { z } from "zod";

export type GeneralResponse = z.infer<typeof GeneralResponseSchema>;
export const GeneralResponseSchema = z.object({
  conversation_id: z.string().nullable().optional(),
  default_limit: z.number().nullable().optional(),
  message: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  success: z.boolean().nullable().optional(),
  url: z.string().nullable().optional(),
});
